import lazyLoadComponent from './lazyLoadComponent';

export default lazyLoadComponent;
